module.exports = __webpack_public_path__ + "static/media/home-left-1.94115e09.png";